module.exports = __webpack_public_path__ + "static/img/index_icon10.99e89b94.png";